<template>
    <div class="customer-description" >
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$lange=='en' ? 'Customer' : '客户详情'" name="description">
                <CustomerComponent></CustomerComponent>
            </el-tab-pane>
        </el-tabs>
        <div class="back-btn" >
            <el-button type="primary" size="mini" @click="backBtn('/workbench')">返回首页</el-button>
            <el-button type="warning" size="mini" @click="backBtn('/admin/customer/list')">返回列表</el-button>
        </div>
    </div>
</template>

<script>
    import CustomerComponent from "./component/CustomerComponent"

    export default {
        name: "CustomerDescription",
        components: {
            CustomerComponent
        },
        data() {
            return {
                customerId: "",
                activeName: "description"
            }
        },
        methods: {
            getData() {
                let data = {
                    id: this.customerId
                    // id: "1163276205022298113"
                }
                this.ccRequest.do("admin/fsb/customer/get", data, "GET").then(res => {
                    console.log(res, "res")
                })
            },
            backBtn(path) {
                this.$router.push({
                    path: path
                });
            },
        },
        mounted() {
            this.customerId = this.$route.query.customerId;
            this.getData();
        }
    }
</script>

<style scoped>

</style>
